<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col-12 comp-grid">
            <div class="">
              <div>
                <template v-if="!loading">
                  <div class="grid">
                    <div class="col-12">
                      <form
                        ref="observer"
                        tag="form"
                        @submit.prevent="startRecordUpdate()"
                      >
                        <!--[form-content-start]-->
                        <div class="grid">
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12 md:col-3 mb-2">
                                {{ $t("account_name") }} *
                              </div>
                              <div class="col-12 md:col-9">
                                <!-- <div class="field mb-0"> -->
                                <InputText
                                  ref="ctrlaccount_name"
                                  v-model.trim="formData.account_name"
                                  :label="$t('account_name')"
                                  type="text"
                                  :placeholder="$t('enter_account_name')"
                                  class="w-full"
                                  :class="getErrorClass('account_name')"
                                >
                                </InputText>
                                <!-- </div> -->
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12 md:col-3 mb-2">
                                {{ $t("account_photo") }}
                              </div>
                              <div class="col-12 md:col-9">
                                <!-- <div class="field mb-0"> -->
                                <div class="mb-3">
                                  <Uploader
                                    :class="getErrorClass('account_photo')"
                                    :auto="true"
                                    :fileLimit="1"
                                    :maxFileSize="3000000"
                                    accept=".jpg,.png,.gif,.jpeg"
                                    :multiple="false"
                                    style="width: 100%"
                                    :label="
                                      $t('choose_files_or_drop_files_here')
                                    "
                                    upload-path="s3uploader/upload/account_photo"
                                    v-model="formData.account_photo"
                                  ></Uploader>
                                </div>
                                <!-- </div> -->
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12 md:col-3 mb-2">
                                {{ $t("allow_two_factor_auth") }} *
                              </div>
                              <div class="col-12 md:col-7">
                                <SelectButton
                                  style="box-shadow: none"
                                  :class="
                                    getErrorClass('allow_two_factor_auth')
                                  "
                                  ref="ctrlallow_two_factor_auth"
                                  v-model="formData.allow_two_factor_auth"
                                  :options="$menus.yes_or_noItems"
                                  optionLabel="label"
                                  optionValue="value"
                                />
                                <div class="text-gray-400 text-sm my-2">
                                  An OTP code will be sent to your email address
                                  every time you attempt to login
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12 md:col-3 mb-2">
                                {{ $t("allow_email_alert") }} *
                              </div>
                              <div class="col-12 md:col-7 mb-2">
                                <SelectButton
                                  style="box-shadow: none"
                                  :class="getErrorClass('allow_email_alert')"
                                  ref="ctrlallow_email_alert"
                                  v-model="formData.allow_email_alert"
                                  :options="$menus.yes_or_noItems"
                                  optionLabel="label"
                                  optionValue="value"
                                />
                                <div class="text-gray-400 text-sm my-2">
                                  You will receive email notifications on CAPS
                                  Application activites and other actions
                                  performed on your account
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12 md:col-3 mb-2">
                                {{ $t("allow_sms_alert") }} *
                              </div>
                              <div class="col-12 md:col-7">
                                <SelectButton
                                  style="box-shadow: none"
                                  :class="getErrorClass('allow_sms_alert')"
                                  ref="ctrlallow_sms_alert"
                                  v-model="formData.allow_sms_alert"
                                  :options="$menus.yes_or_noItems"
                                  optionLabel="label"
                                  optionValue="value"
                                />
                                <div class="text-gray-400 text-sm my-2">
                                  You will receive sms notifications on CAPS
                                  Application statuses
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--[form-content-end]-->
                        <div v-if="showSubmitButton" class="text-center my-3">
                          <hr />
                          <Button
                            type="submit"
                            :label="$t('update')"
                            icon="pi pi-send"
                            :loading="saving"
                          />
                        </div>
                      </form>
                      <slot :submit="submit" :saving="saving"></slot>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="p-3 text-center">
                    <ProgressSpinner style="width: 50px; height: 50px" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { EditPageMixin } from "../../mixins/editpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { i18n } from "../../services/i18n.js";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "accounteditApplicantsPage",
  components: {},
  mixins: [PageMixin, EditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    idName: {
      type: String,
      default: "applicant_id",
    },
    routeName: {
      type: String,
      default: "applicantsaccountedit",
    },
    pagePath: {
      type: String,
      default: "account/edit",
    },
    apiPath: {
      type: String,
      default: "account/edit",
    },
  },
  data() {
    return {
      formData: {
        allow_two_factor_auth: "",
        allow_email_alert: "",
        allow_sms_alert: "",
        account_name: "",
        account_photo: "",
      },
      submitted: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return this.$t("my_account");
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["applicants/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("applicants/setCurrentRecord", value);
      },
    },
  },
  validations() {
    let formData = {
      allow_two_factor_auth: { required },
      allow_email_alert: { required },
      allow_sms_alert: { required },
      account_name: { required },
      account_photo: {},
    };
    return { formData };
  },
  methods: {
    ...mapActions("applicants", ["updateRecord", "fetchRecord"]),
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Please complete the form", "Form is invalid", "error");
        return;
      }
      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let payload = this.normalizedFormData();
      let data = { id, url, payload };
      this.updateRecord(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.msgAfterUpdate);
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          location.reload();
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
    },
    resetForm() {
      //reset form fields value
      this.formData = {
        allow_two_factor_auth: "",
        allow_email_alert: "",
        allow_sms_alert: "",
        account_name: "",
        account_photo: "",
      };
      //raise event to reset other custom form components
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
